<template>
  <section>
    <hero-bar>Project</hero-bar>

    <!-- <main-section> -->
      <div class="px-0 md:px-6 dark:text-slate-100 pt-1 grid grid-cols-3 md:grid-cols-2 lg:grid-cols-4 gap-2 project-list-grid">
        <div class="flex h-20 lg:h-28 lg:w-80 list-card w-10">
          <label for="fileInput"
            class="card w-[100%] h-32 flex justify-center items-top rounded-lg border-4 border-[#fff] shadow-lg shadow-[#1670ff50] hover:shadow-xl  hover:shadow-[#1670ff70] hover:border-[#418aff] transition duration-500 items-center">
            <user-avatar :image="formVar.profile ? fileImage : noFileImage" class="lg:mx-2 h-12 lg:h-24 rounded-lg cursor-pointer"
              classess="h-24 w-28 border-4 border-[#fff] card-inner-image" @click="isModalActive = true" />
            <div class="flex items-center h-32 w-32 font-semibold cursor-pointer text">Upload File</div>
          </label>
          <input name="photo" id="fileInput" class="hidden" type="file" @change="previewProfile($event)" />
        </div>
        <div class="flex h-20 lg:h-28 w-80 list-card">
          <label for="fileList" @click="openList"
            class="card w-[100%] h-32 flex justify-center items-top rounded-lg border-4 border-[#fff] shadow-lg shadow-[#1670ff50] hover:shadow-xl  hover:shadow-[#1670ff70] hover:border-[#418aff] transition duration-500 items-center">
            <user-avatar :image="listImage" class="lg:mx-2 h-12 lg:h-24 rounded-lg cursor-pointer"
              classess="h-20 w-24 border-4 border-[#fff] card-inner-image" @click="isModalActive = true" />
            <div class="flex items-center h-32 w-32 font-semibold cursor-pointer text">File List</div>
          </label>
        </div>
        <div class="lg:flex lg:h-28 w-80 list-card hidden">
          <label for="filecal" @click="openCalculator"
            class="card w-[100%] h-32 flex justify-center items-top rounded-lg border-4 border-[#fff] shadow-lg shadow-[#1670ff50] hover:shadow-xl  hover:shadow-[#1670ff70] hover:border-[#418aff] transition duration-500 items-center">
            <user-avatar :image="calImage" class="lg:mx-2 h-12 lg:h-24 rounded-lg cursor-pointer "
              classess="h-24 w-24 border-4 border-[#fff] card-inner-image" @click="isModalActive = true" />
            <div class="flex items-center h-32 w-32 font-semibold cursor-pointer text">Calculator</div>
          </label>
        </div>
        <div class="flex h-20 lg:h-28 w-80 list-card">
          <label for="filecal" @click="redirectLink('/')"
            class="card w-[100%] h-32 flex justify-center items-top rounded-lg border-4 border-[#fff] shadow-lg shadow-[#1670ff50] hover:shadow-xl  hover:shadow-[#1670ff70] hover:border-[#418aff] transition duration-500 items-center">
            <user-avatar :image="dashImage" class="lg:mx-2 h-12 lg:h-24 rounded-lg cursor-pointer"
              classess="h-20 w-20 border-4 border-[#fff] card-inner-image" @click="isModalActive = true" />
            <div class="flex items-center h-32 w-32 font-semibold cursor-pointer text">Dashbord</div>
          </label>
        </div>
      </div>
    <!-- </main-section> -->
    <main-section v-if="!formVar.listMode && formVar.profile">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 select-none" v-if="storeVar.data.length > 0">
        <card-component class="mb-0" title="Details">
          <div class="overflow-auto h-[44rem] scrol-list">
            <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 w-break" v-for="(item, index) in storeVar.data" :key="index">
              <label class="font-semibold text-xs text-red-400 unselectable">Serial No </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable "> :&nbsp;&nbsp;
                {{
                  item.serialNo }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable "> Title </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable "> :&nbsp;&nbsp;
                {{
                  item.title }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable "> First Name
              </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable "> :&nbsp;&nbsp;
                {{
                  item.firstName }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Last Name </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] break-all unselectable">
                :&nbsp;&nbsp; {{
                  item.lastName }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Initial
              </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.initial }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Email </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.email }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Father Name </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.fatherName }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> DOB </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.dob }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Gender
              </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.gender }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Profession
              </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.profession }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Mailing Street </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.mailingStreet }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Mailing City
              </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.mailingCity }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Mailing Postal Code
              </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.mailingPostalCode }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Mailing Country </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.mailingCountry }}
              </label>

              <label class="font-semibold text-xs text-red-400 unselectable"> Service Provider </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.serviceProvider }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> File No </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.fileNo }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Reference No </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.referenceNo }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Sim No </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.simNo }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Type Of Network </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.typeOfNetwork }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Cell Model No </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.cellModelNo }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> IMEI 1 </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.imei1 }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> IMEI 2 </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.imei2 }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Type Of Plan </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.typeOfPlan }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Credit Card Type </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.creditCardType }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Contract Value </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.contractValue }}
              </label>

              <label class="font-semibold text-xs text-red-400 unselectable"> Date Of Issue </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.dateOfIssue }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Date Of Renewal </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.dateOfRenewal }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Installment </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.installment }}
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Amount In Words </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                <!-- {{item.amountInWords }} -->
              </label>
              <label class="font-semibold text-xs text-red-400 unselectable"> Remarks </label>
              <label class="font-semibold text-xs text-slate-800 dark:text-[#fff] unselectable"> :&nbsp;&nbsp;
                {{
                  item.remarks }}
              </label>
              <base-divider />
            </div>
          </div>
        </card-component>
        <card-component class="mb-0" title="Form Details" v-if="formVar.profile">
          <div class="details-edit-table">
            <base-field label="Serial No" :help="formVar.submit ? serialNoValid : ''">
              <base-control type="text" v-model="formVar.serialNo" placeholder="Enter Serial No"
                @keypress="isNumber($event)" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable"
                autocomplete="off" />
            </base-field>
            <base-field label="Title" :help="formVar.submit ? titleValid : ''">
              <base-control v-model="formVar.title" type="text" placeholder="Enter Title" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart"
                @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="First Name" :help="formVar.submit ? firstNameValid : ''">
              <base-control v-model="formVar.firstName" type="text" placeholder="Enter First Name"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Last Name" :help="formVar.submit ? lastNameValid : ''">
              <base-control v-model="formVar.lastName" type="text" placeholder="Enter Last Name"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Initial" :help="formVar.submit ? initialValid : ''">
              <base-control v-model="formVar.initial" type="text" placeholder="Enter Initial"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Email" :help="formVar.submit ? emailValid : ''">
              <base-control v-model="formVar.email" type="text" placeholder="Enter Email" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart"
                @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Father Name" :help="formVar.submit ? fatherNameValid : ''">
              <base-control v-model="formVar.fatherName" type="text" placeholder="Enter Father Name"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Dob" :help="formVar.submit ? dobValid : ''">
              <base-control v-model="formVar.dob" type="text" placeholder="yyyy-mm-dd"
                @keypress="isNumberWithHighpen($event)" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable"
                autocomplete="off" />
            </base-field>
            <base-field label="Gender" :help="formVar.submit ? genderValid : ''">
              <base-control v-model="formVar.gender" type="text" placeholder="Enter Gender" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart"
                @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Profession" :help="formVar.submit ? professionValid : ''">
              <base-control v-model="formVar.profession" type="text" placeholder="Enter Profession"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Mailing Street" :help="formVar.submit ? mailingStreetValid : ''">
              <base-control v-model="formVar.mailingStreet" type="text" placeholder="Enter Mailing Street"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Mailing City" :help="formVar.submit ? mailingCityValid : ''">
              <base-control v-model="formVar.mailingCity" type="text" placeholder="Enter Mailing City"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Mailing Postal Code" :help="formVar.submit ? mailingPostalCodeValid : ''">
              <base-control v-model="formVar.mailingPostalCode" type="text" placeholder="Enter Mailing Postal Code"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @keypress="isNumberCarAndSpece($event)" @copy="disable"
                autocomplete="off" />
            </base-field>
            <base-field label="Mailing Country" :help="formVar.submit ? mailingCountryValid : ''">
              <base-control v-model="formVar.mailingCountry" type="text" placeholder="Enter Mailing Country"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Service Provider" :help="formVar.submit ? serviceProviderValid : ''">
              <base-control v-model="formVar.serviceProvider" type="text" placeholder="Enter Service Provider"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="File No" :help="formVar.submit ? fileNoValid : ''">
              <base-control v-model="formVar.fileNo" type="text" placeholder="Enter File No" @keypress="isNumber($event)"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Reference No" :help="formVar.submit ? referenceNoValid : ''">
              <base-control v-model="formVar.referenceNo" type="text" placeholder="Enter Reference No"
                @keypress="isNumberAndSpecial($event)" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable"
                autocomplete="off" />
            </base-field>
            <base-field label="Sim No" :help="formVar.submit ? simNoValid : ''">
              <base-control v-model="formVar.simNo" type="text" placeholder="Enter Sim No" @keypress="isNumber($event)"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Type Of Network" :help="formVar.submit ? typeOfNetworkValid : ''">
              <base-control v-model="formVar.typeOfNetwork" type="text" placeholder="Enter Type Of Network"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Cell Model No" :help="formVar.submit ? cellModelNoValid : ''">
              <base-control v-model="formVar.cellModelNo" type="text" placeholder="Enter Cell Model No"
                @keypress="isNumber($event)" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable"
                autocomplete="off" />
            </base-field>
            <base-field label="IMEI 1" :help="formVar.submit ? imei1Valid : ''">
              <base-control v-model="formVar.imei1" type="text" placeholder="Enter EMEI 1" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart"
                @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="IMEI 2" :help="formVar.submit ? imei2Valid : ''">
              <base-control v-model="formVar.imei2" type="text" placeholder="Enter EMEI 2" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart"
                @paste="disable" @copy="disable" autocomplete="off" @keypress="isNumberAndSpecial($event)" />
            </base-field>
            <base-field label="Type Of Plan" :help="formVar.submit ? typeOfPlanValid : ''">
              <base-control v-model="formVar.typeOfPlan" type="text" placeholder="Enter Type Of Plan"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Credit Card Type" :help="formVar.submit ? creditCardTypeValid : ''">
              <base-control v-model="formVar.creditCardType" type="text" placeholder="Enter Credit Card Type"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Contract Value" :help="formVar.submit ? contractValueValid : ''">
              <base-control v-model="formVar.contractValue" type="text" placeholder="Enter Contract Value"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Date Of Issue" :help="formVar.submit ? dateOfIssueValid : ''">
              <base-control v-model="formVar.dateOfIssue" type="text" placeholder="yyyy-mm-dd"
                @keypress="isNumberWithHighpen($event)" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable"
                autocomplete="off" />
            </base-field>
            <base-field label="Date Of Renewal" :help="formVar.submit ? dateOfRenewalValid : ''">
              <base-control v-model="formVar.dateOfRenewal" type="text" placeholder="yyyy-mm-dd"
                @keypress="isNumberWithHighpen($event)" @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable"
                autocomplete="off" />
            </base-field>
            <base-field label="Installment">
              <base-control v-model="formVar.installment" type="text" placeholder="Enter Installment"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Amount In Words">
              <base-control v-model="formVar.amountInWords" type="text" placeholder="Enter Amount In Words"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
            <base-field label="Remarks ">
              <base-control v-model="formVar.remarks" type="text" placeholder="Enter Remarks"
                @keydown="disableTab($event)" @drop="onDrop" @dragstart="handleDragStart" @paste="disable" @copy="disable" autocomplete="off" />
            </base-field>
          </div>
          <base-buttons class="flex justify-center py-4">
            <base-button type="button" @click.prevent="submit()" color="info" label="Submit" effect />
          </base-buttons>
        </card-component>
      </div>
      <new-card v-if="storeVar.data.length <= 0" emptyMessage="Please Upload File..." empty />
    </main-section>

    <main-section v-if="formVar.listMode">
      <card-component class="mb-6 aa" title="List">
        <div class="w-full overflow-x-scroll mt-3">
          <table v-if="storeVar.userProject.length > 0" @copy.prevent @paste.prevent>
            <caption></caption>
            <thead>
              <tr class="flex">
                <th>#</th>
                <th class="w-[8vw] border border-slate-200">Serial No</th>
                <th class="w-[15vw] border border-slate-200">Title</th>
                <th class="w-[15vw] border border-slate-200">First Name</th>
                <th class="w-[15vw] border border-slate-200">Last Name</th>
                <th class="w-[15vw] border border-slate-200">Initial</th>
                <th class="w-[15vw] border border-slate-200">Email</th>
                <th class="w-[15vw] border border-slate-200">Father Name</th>
                <th class="w-[15vw] border border-slate-200">DOB</th>
                <th class="w-[15vw] border border-slate-200">Gender</th>
                <th class="w-[15vw] border border-slate-200">Profession</th>
                <th class="w-[15vw] border border-slate-200">Mailing Street</th>
                <th class="w-[15vw] border border-slate-200">Mailing City</th>
                <th class="w-[15vw] border border-slate-200">Mailing Postal Code</th>
                <th class="w-[15vw] border border-slate-200">Mailing Country</th>
                <th class="w-[15vw] border border-slate-200">Service Provider</th>
                <th class="w-[15vw] border border-slate-200">File No</th>
                <th class="w-[15vw] border border-slate-200">Reference No</th>
                <th class="w-[15vw] border border-slate-200">Sim No</th>
                <th class="w-[15vw] border border-slate-200">Type Of Network</th>
                <th class="w-[15vw] border border-slate-200">Cell Model No</th>
                <th class="w-[15vw] border border-slate-200">IMEI 1</th>
                <th class="w-[15vw] border border-slate-200">IMEI 2</th>
                <th class="w-[15vw] border border-slate-200">Type Of Plan</th>
                <th class="w-[15vw] border border-slate-200">Credit Card Type</th>
                <th class="w-[15vw] border border-slate-200">Contract Value</th>
                <th class="w-[15vw] border border-slate-200">Date Of Issue</th>
                <th class="w-[15vw] border border-slate-200">Date Of Renewal</th>
                <th class="w-[15vw] border border-slate-200">Installment</th>
                <th class="w-[15vw] border border-slate-200">Amount In Words</th>
                <th class="w-[15vw] border border-slate-200">Remarks</th>
                <th class="w-[8vw] border border-slate-200">Action</th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in storeVar.userProject" :key="index" class="flex">
                <td data-label="Sr.No">{{ index + 1 }}</td>
                <td class="w-[8vw] border border-slate-200" data-label="Serial No">{{ item.serialNo }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Title">{{ item.title }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="First Name">{{ item.firstName }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Last Name">{{ item.lastName }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Initial">{{ item.initial }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Email">{{ item.email }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Father Name">{{ item.fatherName }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="DOB">{{ item.dob }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Gender">{{ item.gender }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Profession">{{ item.profession }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Mailing Street">{{ item.mailingStreet }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Mailing City">{{ item.mailingCity }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Mailing Postal Code">{{ item.mailingPostalCode }}
                </td>
                <td class="w-[15vw] border border-slate-200" data-label="Mailing Country">{{ item.mailingCountry }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Service Provider">{{ item.serviceProvider }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="File No">{{ item.fileNo }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Reference No">{{ item.referenceNo }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Sim No">{{ item.simNo }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Type Of Network">{{ item.typeOfNetwork }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Cell Model No">{{ item.cellModelNo }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="IMEI 1">{{ item.imei1 }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="IMEI 1">{{ item.imei2 }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Type Of Plan">{{ item.typeOfPlan }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Credit Card Type">{{ item.creditCardType }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Contract Value">{{ item.contractValue }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Date Of Issue">{{ item.dateOfIssue }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Date Of Renewal">{{ item.dateOfRenewal }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Installment">{{ item.installment }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Amount In Words">{{ item.amountInWords }}</td>
                <td class="w-[15vw] border border-slate-200" data-label="Remarks">{{ item.remarks }}</td>
                <td class="w-[8vw] border border-slate-200" data-label="Action">
                  <base-buttons type="flex justify-start">
                    <base-button color="info" title="Edit" small :icon="mdiTextBoxEdit"
                      @click.prevent="navigate('/project/edit', item.id, item.imageName)" />
                  </base-buttons>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <new-card v-if="storeVar.userProject.length <= 0" empty />
      </card-component>
      <div class="flex justify-center items-center" v-if="storeVar.dataLoader">
        <loading-button />
      </div>
      <base-buttons type="justify-center lg:justify-center" v-if="storeVar.loadMore && !storeVar.dataLoader">
        <base-button type="button" color="info" label="Load More" @click.prevent="loadMoreData()" />
      </base-buttons>
    </main-section>

  </section>
</template>

<script setup>
import {
  mdiTextBoxEdit,
} from "@mdi/js";
import { computed, onBeforeMount, reactive } from "vue";
import fileImage from '../../assets/img/file.png'
import calImage from '../../assets/img/calculator.png'
import listImage from '../../assets/img/list.png'
import dashImage from '../../assets/img/dash2.png'
import noFileImage from '../../assets/img/no-file.jpg'
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const router = useRouter();
const storeVar = computed(() => store.state.Project);

const formVar = reactive({
  limit: 10,
  offset: 0,
  keyword: "",
  status: 'Active',
  editMode: false,
  listMode: false,
  editModeDetails: false,
  profile: null,
  submit: false,

  FileId: null,
  serialNo: null,
  title: null,
  firstName: null,
  lastName: null,
  initial: null,
  email: null,
  fatherName: null,
  dob: null,
  gender: null,
  profession: null,
  mailingStreet: null,
  mailingCity: null,
  mailingPostalCode: null,
  mailingCountry: null,
  serviceProvider: null,
  fileNo: null,
  referenceNo: null,
  simNo: null,
  typeOfNetwork: null,
  cellModelNo: null,
  imei1: null,
  imei2: null,
  typeOfPlan: null,
  creditCardType: null,
  contractValue: null,
  dateOfIssue: null,
  dateOfRenewal: null,
  installment: null,
  amountInWords: null,
  remarks: null,

});
onBeforeMount(() => {
  formVar.listMode = false
  userprofile()
})
function userprofile() {
  store.dispatch('Project/getUserProfile')
  setTimeout(() => {
    auth()
  }, 300);
}
function auth() {
  if (storeVar.value.userProjectStartDate) {
    let date1 = new Date();
    let startDate = new Date(storeVar.value.userProjectStartDate);
    let endDate = new Date(storeVar.value.userProjectEndDate);
    if (date1 > startDate && date1 < endDate) {
      if (date1.getTime() > startDate.getTime() && date1.getTime() < endDate.getTime()) {
        console.log("Both Dates are same");
      } else {
        router.push('/')
      }
    } else {
      router.push('/')
    }
  }
}
function loadData(formFileId) {
  store.dispatch("Project/getUserProject", { formFileId });
}
function getUserProjectList(limit, offset, keyword) {
  store.dispatch("Project/getUserProjectList", { limit, offset, keyword });
}

function loadMoreData() {
  formVar.offset = formVar.offset + formVar.limit;
  loadData(formVar.limit, formVar.offset, formVar.search, formVar.status);
}
function disable(e) {
  e.preventDefault();
}
function onDrop(e){
  e.preventDefault();
}
function handleDragStart(e){
  e.preventDefault();
}
function disableTab(e) {
  if (e.keyCode === 9) {
    focus();
    e.preventDefault();
  }
}
const previewProfile = async (event) => {
  if (event) {
    const input = event.target;
    if (
      input.files[0]
    ) {
      // if (input.files) {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   formVar.profile = e.target.result;
      // };
      if (input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          formVar.FileId = e.target.result
          formVar.listMode = false
          formVar.profile = e.target.result;
          loadData(e.target.result)

        }
        reader.readAsText(input.files[0])
        // reader.readAsDataURL(input.files[0]);
        // let formFileId = input.files[0].name.split('.');
        // formVar.FileId = formFileId[0]
        // formVar.listMode = false
        // loadData(formVar.limit, formVar.offset, formVar.keyword, formFileId[0])
      }
      // }
    }
  }
};

function openCalculator() {
  window.open('Calculator:///');
}

function openList() {
  formVar.profile = null
  document.getElementById("fileInput").value = null
  formVar.listMode = true
  getUserProjectList(formVar.limit, formVar.offset, formVar.keyword)
}
const submit = () => {
  // if (
  //   serialNoValid.value ||
  //   titleValid.value ||
  //   firstNameValid.value ||
  //   lastNameValid.value ||
  //   initialValid.value ||
  //   emailValid.value ||
  //   fatherNameValid.value ||
  //   dobValid.value ||
  //   genderValid.value ||
  //   professionValid.value ||
  //   mailingStreetValid.value ||
  //   mailingCityValid.value ||
  //   mailingPostalCodeValid.value ||
  //   mailingCountryValid.value ||
  //   serviceProviderValid.value ||
  //   fileNoValid.value ||
  //   referenceNoValid.value ||
  //   simNoValid.value ||
  //   typeOfNetworkValid.value ||
  //   cellModelNoValid.value ||
  //   imei1Valid.value ||
  //   imei2Valid.value ||
  //   typeOfPlanValid.value ||
  //   creditCardTypeValid.value ||
  //   contractValueValid.value ||
  //   dateOfIssueValid.value ||
  //   dateOfRenewalValid.value 
  // ) {
  //   formVar.submit = true
  //   return;
  // }
  // formVar.submit = false
  store.dispatch('Project/submitProject', {
    id: storeVar.value.userProjectSubId,
    imageName: formVar.FileId,
    serialNo: formVar.serialNo,
    title: formVar.title,
    firstName: formVar.firstName,
    lastName: formVar.lastName,
    initial: formVar.initial,
    email: formVar.email,
    fatherName: formVar.fatherName,
    dob: formVar.dob,
    gender: formVar.gender,
    profession: formVar.profession,
    mailingStreet: formVar.mailingStreet,
    mailingCity: formVar.mailingCity,
    mailingPostalCode: formVar.mailingPostalCode,
    mailingCountry: formVar.mailingCountry,
    serviceProvider: formVar.serviceProvider,
    fileNo: formVar.fileNo,
    referenceNo: formVar.referenceNo,
    simNo: formVar.simNo,
    typeOfNetwork: formVar.typeOfNetwork,
    cellModelNo: formVar.cellModelNo,
    imei1: formVar.imei1,
    imei2: formVar.imei2,
    typeOfPlan: formVar.typeOfPlan,
    creditCardType: formVar.creditCardType,
    contractValue: formVar.contractValue,
    dateOfIssue: formVar.dateOfIssue,
    dateOfRenewal: formVar.dateOfRenewal,
    installment: formVar.installment,
    amountInWords: formVar.amountInWords,
    remarks: formVar.remarks,
    formFileId: formVar.formId,
  })
  formVar.serialNo = null
  formVar.title = null
  formVar.firstName = null
  formVar.lastName = null
  formVar.initial = null
  formVar.email = null
  formVar.fatherName = null
  formVar.dob = null
  formVar.gender = null
  formVar.profession = null
  formVar.mailingStreet = null
  formVar.mailingCity = null
  formVar.mailingPostalCode = null
  formVar.mailingCountry = null
  formVar.serviceProvider = null
  formVar.fileNo = null
  formVar.referenceNo = null
  formVar.simNo = null
  formVar.typeOfNetwork = null
  formVar.cellModelNo = null
  formVar.imei1 = null
  formVar.imei2 = null
  formVar.typeOfPlan = null
  formVar.creditCardType = null
  formVar.contractValue = null
  formVar.dateOfIssue = null
  formVar.dateOfRenewal = null
  formVar.installment = null
  formVar.amountInWords = null
  formVar.remarks = null
}
const serialNoValid = computed(() => {
  if (!formVar.serialNo) {
    let message = 'Enter Serial No'
    return message
  } else {
    return null
  }
})
const titleValid = computed(() => {
  if (!formVar.title) {
    return 'Enter Title'
  } else {
    return null
  }
})
const firstNameValid = computed(() => {
  if (!formVar.firstName) {
    return 'Enter First Name'
  } else {
    return null
  }
})
const lastNameValid = computed(() => {
  if (!formVar.lastName) {
    return 'Enter Last Name'
  } else {
    return null
  }
})
const initialValid = computed(() => {
  if (!formVar.initial) {
    return 'Enter Initial'
  } else {
    return null
  }
})
const emailValid = computed(() => {
  if (!formVar.email) {
    return 'Enter Email'
  } else {
    return null
  }
})
const fatherNameValid = computed(() => {
  if (!formVar.fatherName) {
    return 'Enter Father Name'
  } else {
    return null
  }
})
const dobValid = computed(() => {
  const valid = /^\d{4}-\d{2}-\d{2}$/;
  if (!formVar.dob) {
    return 'Enter Dob'
  } else if (!valid.test(formVar.dob)) {
    return "Please enter valid Dob!";
  } else {
    return null
  }
})
const genderValid = computed(() => {
  if (!formVar.gender) {
    return 'Enter Gender'
  } else {
    return null
  }
})
const professionValid = computed(() => {
  if (!formVar.profession) {
    return 'Enter Profession'
  } else {
    return null
  }
})
const mailingStreetValid = computed(() => {
  if (!formVar.mailingStreet) {
    return 'Enter Mailing Street'
  } else {
    return null
  }
})
const mailingCityValid = computed(() => {
  if (!formVar.mailingCity) {
    return 'Enter Mailing City'
  } else {
    return null
  }
})
const mailingPostalCodeValid = computed(() => {
  if (!formVar.mailingPostalCode) {
    return 'Enter Mailing Postal Code'
  } else {
    return null
  }
})
const mailingCountryValid = computed(() => {
  if (!formVar.mailingCountry) {
    return 'Enter Mailing Country'
  } else {
    return null
  }
})
const serviceProviderValid = computed(() => {
  if (!formVar.serviceProvider) {
    return 'Enter Service Provider'
  } else {
    return null
  }
})
const fileNoValid = computed(() => {
  if (!formVar.fileNo) {
    return 'Enter File No'
  } else {
    return null
  }
})
const referenceNoValid = computed(() => {
  if (!formVar.referenceNo) {
    return 'Enter Reference No'
  } else {
    return null
  }
})
const simNoValid = computed(() => {
  if (!formVar.simNo) {
    return 'Enter Sim No'
  } else {
    return null
  }
})
const typeOfNetworkValid = computed(() => {
  if (!formVar.typeOfNetwork) {
    return 'Enter Type Of Network'
  } else {
    return null
  }
})
const cellModelNoValid = computed(() => {
  if (!formVar.cellModelNo) {
    return 'Enter Cell Model No'
  } else {
    return null
  }
})
const imei1Valid = computed(() => {
  if (!formVar.imei1) {
    return 'Enter IMEI 1'
  } else {
    return null
  }
})
const imei2Valid = computed(() => {
  if (!formVar.imei2) {
    return 'Enter IMEI 2'
  } else {
    return null
  }
})
const typeOfPlanValid = computed(() => {
  if (!formVar.typeOfPlan) {
    return 'Enter Type Of Plan'
  } else {
    return null
  }
})
const creditCardTypeValid = computed(() => {
  if (!formVar.creditCardType) {
    return 'Enter Credit Card Type'
  } else {
    return null
  }
})
const contractValueValid = computed(() => {
  if (!formVar.contractValue) {
    return 'Enter Contract Value'
  } else {
    return null
  }
})
const dateOfIssueValid = computed(() => {
  const valid = /^\d{4}-\d{2}-\d{2}$/;
  if (!formVar.dateOfIssue) {
    return 'Enter Date Of Issue'
  } else if (!valid.test(formVar.dateOfIssue)) {
    return "Please enter valid Date!";
  } else {
    return null
  }
})
const dateOfRenewalValid = computed(() => {
  const valid = /^\d{4}-\d{2}-\d{2}$/;
  if (!formVar.dateOfRenewal) {
    return 'Enter Date Of Renewal'
  } else if (!valid.test(formVar.dateOfRenewal)) {
    return "Please enter valid Date!";
  } else {
    return null
  }
})
// const installmentValid = computed(() => {
//   if (!formVar.installment) {
//     return 'Enter Installment'
//   } else {
//     return null
//   }
// })
// const amountInWordsValid = computed(() => {
//   if (!formVar.amountInWords) {
//     return 'Enter Amount In Words'
//   } else {
//     return null
//   }
// })

function redirectLink(link, id) {
  router.push({ path: link, query: { id } });
}

function navigate(link, id, imageName) {
  router.push({ path: link, query: { id, imageName } })
}
// validation input from

function isNumber(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/^[0-9]+$/.test(char)) return true;
  else e.preventDefault();
}
function isNumberAndSpecial(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/[0-9-/`~!#*$@_%+=.,'"^&(){}[\]|;:<>?\\]/g.test(char)) return true;
  else e.preventDefault();
}
function isNumberCarAndSpece(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/^[0-9a-zA-Z ]+$/.test(char)) return true;
  else e.preventDefault();
}
function isNumberWithHighpen(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/^[0-9-]+$/.test(char)) return true;
  else e.preventDefault();
}
</script>
